module.exports = __webpack_public_path__ + "media/images/awards/top-banner-icon-f9d27014bc09c92fe0cdf74cee3f4a68.svg";